import { BROADCAST_NOTIFICATION_TYPE } from "@/entities/broadcast-notification";
import { useEventBusListener } from "@/modules/event-bus";

import { useModelDeleteAsyncActionFailed } from "./model-delete-async-action-failed.hook";

export const ModelDeleteAsyncActionFailed = () => {
  const { runAction } = useModelDeleteAsyncActionFailed();
  useEventBusListener(
    BROADCAST_NOTIFICATION_TYPE.ASYNC_DELETE_FAILED,
    runAction
  );

  return <></>;
};
